import React from 'react';
import { Form, Input } from 'antd';
import { NamePath, Rule } from 'rc-field-form/lib/interface';

export type TextInputProps = {
  name: NamePath;
  label: string;
  value?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  rules?: Rule[];
  maxLength?: number;
  tooltip?: React.ReactNode; 
  extra?: React.ReactNode; 
};

export function TextInput(props: TextInputProps) {
  const handleChange = (value: string) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };

  const rules = [...(props.rules ?? []), { required: props.required, message: `${props.label} is required` }];

  return (
    <>
      <Form.Item name={props.name} label={props.label} rules={rules} tooltip={props.tooltip} extra={props.extra}>
        <Input
          value={props.value}
          maxLength={props.maxLength ?? 255}
          onChange={(event) => {
            handleChange(event.target.value);
          }}
          onPressEnter={(event) => {
            handleChange(event.currentTarget.value);
          }}
          disabled={props.disabled}
          placeholder={props.placeholder}
        />
      </Form.Item>
    </>
  );
}
